import settings from '@/settings.js'

export function image (value) {
  if (value === '') return settings.upload + 'none/none.png'
  else return settings.upload + value
}
